import { createApp } from "vue"
import App from "./App.vue"
import router from "./router"
import "element-plus/theme-chalk/index.css"
import { createPinia } from "pinia"
import setupI18n, { watchRouteChange } from "./lang/i18n"
// import "./registerServiceWorker"
import "@qcplay/platform-ui/style"
import { getBaseFontSize, getAppNameByDomain } from "@/utils/utils"
import { platformStore } from "@/store/index"
import directives from "@/directives" // 导入自定义指令
const pinia = createPinia() //创建pina实例

// 存储动态导入的 CSS 模块，用于卸载
let jaFontModule = null

/**
 * 动态加载/卸载 jp-font 字体库（本地文件）
 * @param {boolean} shouldLoad - 是否加载字体
 */
async function loadJpFont(shouldLoad) {
  const fontId = "jp-font-stylesheet"
  const existingLink = document.getElementById(fontId)

  if (shouldLoad) {
    // 如果需要加载且尚未加载，则动态导入字体文件
    if (!existingLink && !jaFontModule) {
      try {
        // 动态导入 CSS 文件，webpack 会处理并注入样式
        jaFontModule = await import("@/assets/style/ja-font.css")
        // 动态导入 CSS 后，webpack 会自动创建 link 标签
        // 我们需要找到这个 link 标签并添加 id，以便后续可以移除
        const links = document.querySelectorAll('link[href*="ja-font"]')
        if (links.length > 0) {
          const link = links[links.length - 1]
          link.id = fontId
        }
      } catch (error) {
        console.error("加载 jp-font 字体库失败:", error)
      }
    }
  } else {
    // 如果不需要加载且已加载，则移除 link 标签
    if (existingLink) {
      existingLink.remove()
      jaFontModule = null
    }
  }
}

// 根据当前域名动态更新页面标题
document.title = getAppNameByDomain()

// main.js
const baseFontSize = getBaseFontSize() || "1"
document.documentElement.style.setProperty(
  "--base-font-size",
  `${baseFontSize}px`
)
function setRemUnit() {
  const docEl = document.documentElement
  const clientWidth = docEl.clientWidth

  if (!clientWidth) return

  // 设置根元素的字体大小，假设设计稿宽度为750px
  // const baseSize = 75; // 750 / 10 = 75
  let fontSize = clientWidth / 10
  // 限制最大页面宽度为750px
  if (clientWidth > 750) {
    fontSize = 750 / 18
  } else if (clientWidth >= 500) {
    // 折叠屏
    fontSize = clientWidth / 18
  }

  // 设置一个最小字体大小，防止在小屏幕上字体过小
  const minFontSize = 12 // 你可以根据需要调整
  if (fontSize < minFontSize) {
    fontSize = minFontSize
  }

  docEl.style.fontSize = fontSize + "px"
}
// 初始化
setRemUnit()
// 窗口大小变化时重新设置根元素的字体大小
window.addEventListener("resize", setRemUnit)
async function bootstrap() {
  if (window.navigator && navigator.serviceWorker) {
    navigator.serviceWorker.getRegistrations().then((registrations) => {
      for (let registration of registrations) {
        registration.unregister() // 强制注销
      }
    })
  }
  const app = createApp(App)
  // 先注册 Pinia，确保 store 可以使用
  app.use(pinia)

  // 获取 store 实例
  const store = platformStore()

  // 初始化时检查语言并加载字体
  if (store.lang === "ja-jp") {
    loadJpFont(true)
  }

  // 监听语言变化，动态加载/卸载字体
  let lastLang = store.lang
  store.$subscribe((mutation, state) => {
    const currentLang = state.lang
    // 当语言发生变化时，动态加载/卸载字体
    if (currentLang !== lastLang) {
      lastLang = currentLang
      loadJpFont(currentLang === "ja-jp")
    }
  })

  // 异步加载并等待 i18n 实例
  const i18n = await setupI18n()

  // 将i18n实例挂载到window对象，方便在组件中访问
  window.$i18n = i18n.global

  // 使用 router、pinia 和 i18n 中间件
  app.use(router)

  app.use(i18n)

  // 注册全局自定义指令（埋点指令等）
  app.use(directives)

  // 启用路由监听，在路由切换时重新检查配置
  watchRouteChange(i18n, router)

  // 挂载应用到 DOM 上
  app.mount("#app")
}
bootstrap()
